export default __webpack_public_path__ + "static/media/marlin.0b6e1cba.jpg";